<template>
	
<div class="benefits">

	<div class="benefits-title">{{ section.treatment.more.benefit.title }}</div>

	<div class="benefits-text" v-html="text"></div>

</div>

</template>

<script>

export default {

	props: ['section', 'treatment'],

	computed: {

		text: function() {

			return this.section.treatment[this.treatment].benefit.replace(/{{bullet}}/g, '<span class="bullet"></span>')

		}

	}
	
}

</script>

<style scoped>

.benefits {
	background-color: #fff;
	padding: 32px;
	border-radius: 17px;
	margin-bottom: 16px;
}

.benefits-title {
	color: #343434;
	font-size: 24px;
	margin-bottom: 32px;
	font-weight: 600;
}

.benefits-text {
	color: #343434;
	font-size: 18px;
	line-height: 22px;
}

.benefits-text >>> .bullet {
	width: 22px;
	height: 22px;
	display: inline-block;
	vertical-align: middle;
	background-size: contain;
	background-position: 0% 0px;
	background-repeat: no-repeat;
	background-size: 16px 16px;
	background-image: url(~@/assets/aid/common/bullet.png);
}

.is-patient .benefits-text >>> .bullet {
	background-image: url(~@/assets/aid/common/link.png);
}

</style>